// Vendor + theme CSS FIRST. Components are consumed from source and import
// their own stylesheets, so Vite places each one where its JS is first
// imported; anything imported above this point would land BEFORE Bootstrap
// and lose every equal-specificity tie (e.g. .tc-icon-button vs .btn → the
// misaligned builder toolbar gear). Legacy order: vendor → theme → components
// → app.
import 'prosemirror-view/style/prosemirror.css';
import 'react-datepicker/dist/react-datepicker.css';
import '@fortawesome/fontawesome-pro/css/all.min.css';
import '@techchange/tc-theme/tc-theme.css';

import React from 'react';
import { loadableReady } from '@loadable/component';
import { initEmojiData, registerServiceWorker } from '@techchange/components';
// Polyfills for ECMAScript features
import 'core-js/stable';
import { CookiesProvider } from 'react-cookie';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'regenerator-runtime/runtime';

import AppWrapper from './boot/AppWrapper';
import { AppProvider } from './shared/contexts/AppContext';
import { SSRDataProvider } from './shared/contexts/SSRDataContext';

// Initialize emoji-mart with the twitter data set
initEmojiData();

// Register service worker
registerServiceWorker('/static/service-worker.js', { scope: '/' });

// Grab the preloaded-data bag from a global injected into server-generated HTML
const preloadedState = window.__PRELOADED_STATE__ || {};

// Initialize DOM accessibility testing in development
// eslint-disable-next-line global-require
// const axe = require('@axe-core/react');

// axe(React, ReactDOM, 1000);

const authState = preloadedState?.authState;
const currentUser = preloadedState?.currentUser;
const myOrganization = preloadedState?.myOrganization;
const preferredLanguage = preloadedState?.preferredLanguage;
const messages = preloadedState?.messages;

const component = (
	<SSRDataProvider initialData={preloadedState}>
		<DndProvider backend={HTML5Backend}>
			<CookiesProvider>
				<BrowserRouter>
					<AppProvider
						preloadedData={{
							authState,
							user: currentUser,
							organization: myOrganization,
						}}>
						<AppWrapper preloadedData={{ preferredLanguage, messages }} />
					</AppProvider>
				</BrowserRouter>
			</CookiesProvider>
		</DndProvider>
	</SSRDataProvider>
);

loadableReady(() => {
	hydrateRoot(document.getElementById('root'), component);
});
